import React from 'react';
import cx from 'classnames';
import { Table, Icon } from 'semantic-ui-react';
import { Dropdown, Menu, notification } from 'antd';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import M4ModifierExclusionStore from './Store';
import { TableEmptyMessage, TableFooterPagination, TableHeader } from '../../shared/table';
import { deleteM4ModifierExclusion } from './Service';
import * as api from '../../../stores/api';

const columns = [{ title: '' }, { title: 'Exclusion Codes', sortKey: 'ExclusionCode' }];

@observer
class M4ModifierExclusionTable extends React.Component {
  openModal = options => {
    return M4ModifierExclusionStore.toggleModal(true, options);
  };
  handleDelete = id => {
    M4ModifierExclusionStore.setFieldsValue({ loading: true });
    Promise.all([deleteM4ModifierExclusion(id)])
      .then(([responseDelete]) => {
        if (responseDelete.status === 'success') {
          notification.destroy();
          notification.success({
            message: 'Success',
            description: 'Data has been deleted successfully.',
            duration: 3,
          });
          M4ModifierExclusionStore.refetch({}, true);
        }
      })
      .catch(() => {
        notification.destroy();
        notification.error({
          message: 'Error',
          description: 'An error occurred, please try again',
          duration: 3,
        });
      });
  };
  handleEdit = (id, record) => {
    return M4ModifierExclusionStore.toggleModal(true, {
      modalType: 'create',
      id,
      record,
    })();
  };
  renderTableAction = (id, record) => {
    return (
      <Dropdown
        trigger={['click']}
        overlay={
          <Menu>
            <Menu.Item onClick={() => this.handleEdit(id, record)}>Edit</Menu.Item>
            <Menu.Item
              onClick={this.openModal({
                modalType: 'confirm',
                message: 'Do you want to delete this item?',
                onOk: () => this.handleDelete(id),
              })}
              //onClick={() => this.handleDelete(id)}
            >
              Delete
            </Menu.Item>
          </Menu>
        }
      >
        <Icon name="ellipsis vertical" />
      </Dropdown>
    );
  };

  renderTableBody = (colSpan, data) => {
    if (!data || !data.itemList.length) {
      return <TableEmptyMessage colSpan={colSpan} />;
    }

    return data.itemList.map(({ Id, ...record }) => (
      <Table.Row key={Id}>
        {api.isAdmin() && <Table.Cell className="Cell-actions">{this.renderTableAction(Id, record)}</Table.Cell>}
        {api.isAdmin() ? (
          <Table.Cell className="Cell-link Cell-nowrap" selectable onClick={() => this.handleEdit(Id, record)}>
            <Link to="#" onClick={() => this.handleEdit(Id, record.ExclusionCode)}>
              {record.ExclusionCode}
            </Link>
          </Table.Cell>
        ) : (
          <Table.Cell className="Cell-nowrap">{record.ExclusionCode}</Table.Cell>
        )}
      </Table.Row>
    ));
  };

  handlePageClick = page => {
    M4ModifierExclusionStore.refetch({ curPage: page });
  };

  render() {
    const { loading, data, sortColumn, sortDirection } = M4ModifierExclusionStore;
    const colummn_ = api.isAdmin() ? columns : columns.filter(i => i.title);
    const colSpan = colummn_.length;

    return (
      <Table sortable striped celled className={cx({ disabled: loading })}>
        <TableHeader
          columns={colummn_}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          onSort={M4ModifierExclusionStore.handleSort}
        />
        <Table.Body>{this.renderTableBody(colSpan, data)}</Table.Body>
        <TableFooterPagination
          colSpan={colSpan}
          currentPage={M4ModifierExclusionStore.curPage}
          totalPage={M4ModifierExclusionStore.totalPage}
          totalItems={M4ModifierExclusionStore.totalItems}
          onPageClick={this.handlePageClick}
        />
      </Table>
    );
  }
}
export default M4ModifierExclusionTable;
